import { render, staticRenderFns } from "./newPromotionOther.vue?vue&type=template&id=57d63245&scoped=true&"
import script from "./newPromotionOther.vue?vue&type=script&lang=js&"
export * from "./newPromotionOther.vue?vue&type=script&lang=js&"
import style0 from "./newPromotionOther.vue?vue&type=style&index=0&id=57d63245&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d63245",
  null
  
)

export default component.exports